import { IEnumOption } from 'modules/shared/interfaces/enumOptions';

export enum Gender {
	MAN = 'M',
	FEMALE = 'F',
}
export enum AuthMethod {
	GOOGLE = 'G',
	FACEBOOK = 'F',
	EMAIL = 'E',
	APPLE = 'A',
}

export const genderEnumOptions: IEnumOption[] = [
	{
		label: 'Male',
		value: Gender.MAN,
	},
	{
		label: 'Female',
		value: Gender.FEMALE,
	},
];

export const authMethodEnumOptions: IEnumOption[] = [
	{
		label: 'Apple',
		value: AuthMethod.APPLE,
	},
	{
		label: 'Google',
		value: AuthMethod.GOOGLE,
	},
	{
		label: 'Facebook',
		value: AuthMethod.FACEBOOK,
	},
	{
		label: 'Email',
		value: AuthMethod.EMAIL,
	},
];

export enum EndUserWordReviewType {
	VOCAB_WORD,
	VERB_WORD, // Combo(pronoun + verb)
	GRAMMAR_WORD, // Combo(modifier + grammar object)
	SUBJECT, // Sorting lesson subject
	SIGHT_WORD,
}

export const endUserWordReviewTypeEnumOptions: IEnumOption[] = [
	{
		value: EndUserWordReviewType.VOCAB_WORD,
		label: 'Vocab',
	},
	{
		value: EndUserWordReviewType.VERB_WORD,
		label: 'Verb/Pronoun',
	},
	{
		value: EndUserWordReviewType.GRAMMAR_WORD,
		label: 'Grammar/Modifier',
	},
	{
		value: EndUserWordReviewType.SUBJECT,
		label: 'Subject',
	},
	{
		value: EndUserWordReviewType.SIGHT_WORD,
		label: 'Sight Word',
	},
];
